import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {IBaseResponse, WebService} from '../../services';


export interface ISimpleMenuItem {
	id: string;
	name: string;
	description: string;
}

export interface ISimpleMenuCategory {
	id: string;
	name: string;
	items: ISimpleMenuItem[];
}


export interface ISimpleMenu {
	id: string;
	name: string;
	categories: ISimpleMenuCategory[];
}

export interface ISimpleMenuStoreState {
	menu: ISimpleMenu | null;
}

@Module({name: 'simpleMenu', namespaced: true})
class SimpleMenuModule extends VuexModule implements ISimpleMenuStoreState {
	menu: ISimpleMenu | null = null;

	@Action
	async fetchMenu() {
		const response = await WebService.authenticatedClient.get<IBaseResponse<{menu: ISimpleMenu}>>('menu');
		this.setMenu(response.data.data.menu);
	}

	@Mutation
	public setMenu(menu: ISimpleMenu) {
		this.menu = menu;
	}

	@Mutation
	public clearMenu() {
		this.menu = null;
	}
}






export {
	SimpleMenuModule
};
